
import DataEmpty from "@/views/components/DataEmpty/DataEmpty.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import config from "./config";
import { getDeviceLattice } from "@/api/print";
import { dynamicUrlPost } from "@/api/service";
import { LogHelper } from "@/common/LogHelper";
import dayjs from "dayjs";
import { PaperSizeEnum, PaperSizeOptions } from "@/common/enum/paper-size";
import { PrintUtils } from "@/common/print-utils";

@Component({
  name: "BigBagPrintnNew",
  computed: {
    PaperSizeOptions() {
      return PaperSizeOptions
    }
  },
  components: {
    YtoTable,
    DataEmpty,
  },
})
export default class extends Vue {
  public printButtonDisabled = false;
  public defaultPrinter = "";
  private typeOptions = [];
  private typeValue = "";
  private queryString = "";
  private input_PaperSize = "";
  private hasPaperSizeOption = false;
  private showPrintInterceptBagBtn = false;
  private printCount = 0;
  private items = [];
  public IsPainting = false;
  private HBPrintedItems = [];
  public options = [
    {
      value: "",
      label: "",
    },
  ];
  private currentRowIndex = "";
  private printDataResultShowList = [
    // {
    //   ID: "",
    //   Name: "嘉峪关中转包-934",
    //   Type: "汽运",
    //   edit: false,
    //   Count: "",
    //   UnpackOrgCode: ""
    // }
  ];
  public multipleSelection = [];
  private searchResultShowList = [];
  private config = config;
  public isShowInterceptBagPrintModal: boolean = false;
  public interceptBagPrintForm = this.initializeInterceptBagPrintForm();

  created() {}
  mounted() {
    try {
      this.SetTypeItems();
      this.hasPaperSizeOption = PrintUtils.hasPaperSizeOption();
      this.showPrintInterceptBagBtn = !!(obj_System_Core && obj_System_Core.saveYtoCommonConfig)
      this.input_PaperSize = this.hasPaperSizeOption ? PrintUtils.getDefaultPaperSize() : "";
    } catch (error) {
      console.log("格口包签打印界面:注册回调函数异常" + error);
    }
  }

  public initializeInterceptBagPrintForm() {
    return  {
      latticeNo: this.loadInterceptLatticeNo(),
      latticeName: "拦截件",
      printCount: "",
    }
  }

  //获取默认打印机
  private getDefaultPrinter() {
    var printersStr = obj_Printer_Core.getAllPrinters();
    if (printersStr == null || printersStr.length == 0) {
      return;
    }
    var printers = JSON.parse(printersStr);
    printers.forEach((element) => {
      let printName = element.printName;
      let defultPrinter = false;
      element.propertyDatas.forEach((_element) => {
        if (_element.Name === "Default" && _element.Value === true) {
          this.defaultPrinter = printName;
          return;
        }
      });
    });
  }
  //设置摆臂格口方案
  private SetTypeItems() {
    var obj = JSON.parse(getDeviceLattice());
    let items = [];
    if (obj?.data?.length > 0) {
      obj.data.forEach((response) => {
        if (response.schemeDtoList?.length > 0) {
          response.schemeDtoList.forEach((li) => {
            let item = {
              label: response.name + "  " + li.latticeSchemeName,
              value: li.latticeSchemeId,
            };
            items.push(item);
          });
        }
      });
    }

    this.typeOptions = items;
    this.typeValue = items[0].value;
  }
  //根据摆臂id向网关请求数据
  private SubmitSearch() {
    if (this.typeValue == null || this.typeValue.length == 0) {
      return;
    }
    var res = JSON.parse(
      dynamicUrlPost(
        "/Yto_BusiGateway/print/getDeviceLatticePrint?latticeSchemeId=" +
          this.typeValue,
        JSON.stringify({}),
        30000,
        false
      )
    );
    let t = this.queryString.toString().trim();
    debugger;
    if (res?.data?.length > 0) {
      if (t.length == 0) {
        this.printDataResultShowList = res.data;
        this.$message.success("查询完成");

        return;
      }
      let dataTemp = res.data.filter(
        (f) =>
          (f.destOrgName + "").indexOf(t) != -1 ||
          (f.destOrgCode + "").indexOf(t) != -1 ||
          (f.latticeNo + "").indexOf(t) != -1 ||
          (f.threeCode + "").indexOf(t) != -1
      ); //.distinctBy(f => f.DestOrgCode +"" + f.DestOrgName + f.LatticeNo + f.ThreeCode).ToArray();
      let data = [];
      // let  = JSON.parse(JSON.stringify(data));
      let keyArray = [];
      dataTemp.forEach((element) => {
        let keyStr =
          element.destOrgName +
          "|" +
          element.destOrgCode +
          "|" +
          element.latticeNo +
          "|" +
          element.threeCode;
        if (keyArray.indexOf(keyStr) == -1) {
          data.push(element);
          keyArray.push(keyStr);
        }
      });
      this.printDataResultShowList = data;
    } else {
      this.printDataResultShowList = [];
    }
    this.$message.success("查询完成");
  }

  //打印按钮
  private SubmitPrintFunc(list?) {
    this.printButtonDisabled = true;
    //两秒之后可打印按钮开放
    setTimeout(() => {
      this.printButtonDisabled = false;
    }, 2000);

    //获取默认打印机
    this.getDefaultPrinter();
    // obj_InboundVirtualPacketPrint.submitPrint(this.multipleSelection);
    let printlist = list ? list : this.multipleSelection;
    if (printlist == null || printlist.length < 1) {
      this.$message.error("请重新选择打印项,或者重新输入数量");
      return;
    }
    this.items = [];
    let totalCount = 0;
    let singleCount = 0;

    try {
      printlist.forEach((item) => {
        try {
          singleCount = Number.parseInt(item.countNum.toString());
        } catch (ex) {
          this.$message.error("输入数据有误,请重新输入数量");
          throw new Error("EndIterative");
        }
        if (singleCount > 500) {
          this.$message.error("单项的打印数量超过500张,请重新输入数量");
          throw new Error("EndIterative");
        }
        totalCount = totalCount + singleCount;
      });
    } catch (error) {
      if (error.message == "EndIterative") {
        return;
      }
    }

    if (totalCount > 10000) {
      this.$message.error("打印的总数超过10000张,请重新输入需要打印的数量");
      return;
    }
    //收集打印请求
    printlist.forEach((item) => {
      singleCount = Number.parseInt(item.countNum.toString());
      this.items.push({
        IsSelected: true,
        PrintCount: singleCount,
        DestOrgCode:
          item.destOrgCode == null ? "" : item.destOrgCode.toString(),
        DestOrgName:
          item.destOrgName == null ? "" : item.destOrgName.toString(),
        LatticeNo: item.latticeNo == null ? "" : item.latticeNo.toString(),
        ThreeCode: item.threeCode == null ? "" : item.threeCode.toString(),
      });
    });
    if (this.items.length > 0) {
      LogHelper.Print("格口包签打印开始");
      this.PrintRequest();
    }
  }

  public showInterceptBagPrintModal() {
    this.interceptBagPrintForm = this.initializeInterceptBagPrintForm();
    this.isShowInterceptBagPrintModal = true;
    this.$nextTick(() => {
      const { latticeNo } = this.interceptBagPrintForm;
      if (latticeNo) {
        (this.$refs.printCountRef as any)?.focus();
      } else {
        (this.$refs.latticeNoRef as any)?.focus();
      }
    });
  }

  public onLatticeNoChanged(value) {
    if (value && !/^\d{1,4}$/.test(value)) {
      return;
    }

    this.interceptBagPrintForm.latticeNo = value;
  }

  public printInterceptBag() {
    const { latticeNo, latticeName, printCount } = this.interceptBagPrintForm;
    if (!latticeNo) {
      this.$message.error("格口号不能为空");
      return;
    }
    if (!latticeName || latticeName.trim() === "") {
      this.$message.error("格口名称不能为空");
      return;
    }
    if (!printCount) {
      this.$message.error("请输入打印数量");
      return;
    }
    const nCount = Number(printCount);
    if (nCount <= 0) {
      this.$message.error("打印数量必须大于0");
      return;
    }

    const printList = [
      {
        destOrgCode: "",
        destOrgName: latticeName.trim(),
        threeCode: "",
        latticeNo: latticeNo,
        countNum: nCount,
      }
    ];

    this.isShowInterceptBagPrintModal = false;
    this.interceptBagPrintForm.printCount = "";
    this.saveInterceptLatticeNo(latticeNo);

    this.SubmitPrintFunc(printList);
  }

  //确认打印
  public async PrintRequest() {
    if (this.IsPainting) {
      this.$message.error("格口包签正在打印中，请勿重复打印");
      return;
    }
    try {
      this.IsPainting = true;
      if (this.items == null) {
        return;
      }

      var b = this.items.some((f) => f.IsSelected && f.PrintCount > 0);
      if (b) {
        this.OnPrint(this.items);
        PrintUtils.savePaperSize(this.input_PaperSize);
      } else {
        this.$message.error("请先选择需要打印的项，或者输入预打印\r\n的数量");
      }

      this.IsPainting = false;
    } catch (ex) {
      LogHelper.Print("格口包签打印方法Onpaint出现异常" + ex);
      this.IsPainting = false;
    } finally {
      this.IsPainting = false;
    }
  }
  //获取模板名称
  private getTemplateName() {
    return PrintUtils.buildTemplateNameByPaperSize("\\PrintTemplate\\LatticeNoPrint", this.input_PaperSize) + ".frx";
  }

  //打印开始
  private async OnPrint(item) {
    try {
      if (item.length == 0) {
        return;
      }
      await this.printStart(item);
      LogHelper.Print("格口包签打印" + "打印结束");
    } catch (ex) {
      LogHelper.Print("打印出错:" + ex);
    }
  }
  //开始打印
  private async printStart(item) {
    for (let index = 0; index < item.length; index++) {
      if (
        this.HBPrintedItems.some(
          (f) =>
            f.DestOrgName == item[index].DestOrgName &&
            f.DestOrgCode == item[index].DestOrgCode &&
            f.ThreeCode == item[index].ThreeCode &&
            f.LatticeNo == item[index].LatticeNo
        )
      ) {
        let first = this.HBPrintedItems.filter(
          (f) =>
            f.DestOrgName == item[index].DestOrgName &&
            f.DestOrgCode == item[index].DestOrgCode &&
            f.ThreeCode == item[index].ThreeCode &&
            f.LatticeNo == item[index].LatticeNo
        )[0];
        first.PrePrintTotal += item[index].PrintCount;
      }
      for (let _index = 0; _index < item[index].PrintCount; _index++) {
        //展示打印数量
        await this.ShowAsync(index); //加这段话会让界面刷新，但是会有一点影响打印速度
        this.printOne(_index, item[index]);
      }
    }
  }
  /**
   * 自定义函数名：PrefixZero
   * @param num： 被操作数
   * @param n： 固定的总位数
   */
  private PrefixZero(numStr: string, number: number) {
    let _num = parseInt(numStr.trim());
    let _numStr = _num.toString();
    while (_numStr.length < number) {
      _numStr = "0" + _numStr;
    }
    return _numStr;
  }
  //打印单条数据
  private printOne(index, item) {
    try {
      let templatePath = this.getTemplateName();
      var _data = {
        Code: "",
        R1: "",
        R2: "",
        Line3: "",
      };

      _data.Code =
        "JG" + dayjs().format("HHmmssSSS") + this.PrefixZero(item.LatticeNo, 2);
      _data.R1 = this.PrefixZero(item.LatticeNo, 2);
      _data.R2 = item.DestOrgName.trim();
      _data.Line3 = item.ThreeCode.trim();
      debugger;
      var array = [];
      array.push(_data);
      var result = obj_Printer_Core.print(
        JSON.stringify(array),
        templatePath,
        this.defaultPrinter
      );

      if (
        this.HBPrintedItems.some(
          (f) =>
            f.DestOrgName == item.DestOrgName &&
            f.DestOrgCode == item.DestOrgCode &&
            f.ThreeCode == item.ThreeCode &&
            f.LatticeNo == item.LatticeNo
        )
      ) {
        let first = this.HBPrintedItems.filter(
          (f) =>
            f.DestOrgName == item.DestOrgName &&
            f.DestOrgCode == item.DestOrgCode &&
            f.ThreeCode == item.ThreeCode &&
            f.LatticeNo == item.LatticeNo
        )[0];
        debugger;
        // if (index == 0) {
        // first.PrePrintTotal = first.PrePrintTotal + 1;
        // }

        first.PrintedCount = first.PrintedCount + 1;
        //this.PrintResultView.Invalidate();
      } else {
        var i = {
          DestOrgName: item.DestOrgName,
          DestOrgCode: item.DestOrgCode,
          ThreeCode: item.ThreeCode,
          LatticeNo: item.LatticeNo,

          FailedCount: 0,
          PrePrintTotal: item.PrintCount,
          PrintedCount: 1,
        };
        this.HBPrintedItems.unshift(i);
        //this.PrintResultView.Invalidate();
      }
      LogHelper.Print(
        "格口包签打印第" +
          (index + 1) +
          "张打印结束:" +
          "WayBillNo:" +
          item.WaybillNo
      );
    } catch (e) {
      LogHelper.Print("打印出错:" + e);

      if (
        this.HBPrintedItems.some(
          (f) =>
            f.DestOrgName == item.DestOrgName &&
            f.DestOrgCode == item.DestOrgCode &&
            f.ThreeCode == item.ThreeCode &&
            f.LatticeNo == item.LatticeNo
        )
      ) {
        let first = this.HBPrintedItems.filter(
          (f) =>
            f.DestOrgName == item.DestOrgName &&
            f.DestOrgCode == item.DestOrgCode &&
            f.ThreeCode == item.ThreeCode &&
            f.LatticeNo == item.LatticeNo
        )[0];
        // if (index == 0) {
        // first.PrePrintTotal = first.PrePrintTotal + 1;
        // }
        first.FailedCount = first.FailedCount + 1;
        //this.PrintResultView.Invalidate();
      } else {
        var i = {
          DestOrgName: item.DestOrgName,
          DestOrgCode: item.DestOrgCode,
          ThreeCode: item.ThreeCode,
          LatticeNo: item.LatticeNo,

          FailedCount: 1,
          PrePrintTotal: item.PrintCount,
          PrintedCount: 0,
        };
        this.HBPrintedItems.unshift(i);
        //this.PrintResultView.Invalidate();
      }
    }

    setTimeout(() => {
      this.PrintedDataCallback(this.HBPrintedItems);
    }, 10);

    // }
  }
  //展示打印进度
  public async ShowAsync(index) {
    return new Promise((resolve) => {
      setTimeout(() => {
        // // this.printCount = index + 1;
        resolve("success");
      }, 300);
    });
  }
  //打印数据显示
  private PrintedDataCallback(printedDatas) {
    this.searchResultShowList = printedDatas;
  }
  //表格index选取
  private onRowClick(row, event, column) {
    this.currentRowIndex = row.row_index;
  }
  //表格index选取

  private tableRowClassName({ row, rowIndex }) {
    row.row_index = rowIndex;
  }
  //表格选中select 跳转到input框
  private handelSelectPrintRow(selection, row, index) {
    this.multipleSelection = selection;
    this.$nextTick(() => {
      var el = document.getElementById("editinput" + row.row_index);
      this.selectElementContents(el);
    });
  }

  //表格选择的内容
  public handleSelectionChange(val) {
    this.multipleSelection = val;
  }

  //获取光标/全选
  public selectElementContents(el) {
    try {
      // el.blur();
      el.focus();
      el.select();
    } catch (error) {
      console.log("selectElementContents error：" + error);
    }
  }

  public saveInterceptLatticeNo(latticeNo) {
    try {
      if (obj_System_Core.saveYtoCommonConfig) {
        obj_System_Core.saveYtoCommonConfig({ InterceptBagLatticeNo: latticeNo });
      }
    } catch (e) {
      console.log(e);
    }
  }

  public loadInterceptLatticeNo() {
    try {
      const configStr = obj_System_Core.getYtoCommonConfig();
      const config = JSON.parse(configStr);
      return config.InterceptBagLatticeNo ?? "";
    } catch (e) {
      console.log(e);
    }
  }
}
